var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactNoimage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.9a2.1 2.1 0 110 4.2 2.1 2.1 0 010-4.2zm0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H1.9V13c0-.64 3.13-2.1 6.1-2.1zM8 0C5.79 0 4 1.79 4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z",
    id: "contact_noimage_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#A6ADC6",
    fill: "#FFF",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "contact_noimage_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#contact_noimage_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#contact_noimage_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#contact_noimage_svg__b)",
    fill: "#A6ADC6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-4h24v24H-4z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8 7h24v24H8z"
  }))));
}

export default __webpack_public_path__ + "./fonts/contact_noimage.6c635dde6ef09e24d715903d9018a975.svg";
export { SvgContactNoimage as ReactComponent };